import { deepmerge } from '@material-ui/utils';

function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return deepmerge(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

export default merge;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/system/esm/merge.js
// module id = 337
// module chunks = 1